import { primary, text } from "@/theme/colors";
import { getLeadingNameChars } from "@/utils/string";
import { Box, styled } from "@mui/material";
import { FC } from "react";

type TUserInitialAvatarProps = {
  fullName?: string;
  size?: number;
};

export const UserInitialAvatar: FC<TUserInitialAvatarProps> = ({ fullName, size = 48 }) => {
  return (
    <AvatarCircle sx={{ width: size, height: size, fontSize: size * 0.42 }}>{getLeadingNameChars(fullName)}</AvatarCircle>
  );
};

const AvatarCircle = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${primary[700]};
  color: ${text.white};
  font-weight: 700;
  line-height: 1;
`;
